namespace Gordic.Uda.WebControls {
    let gcontent = Decorators.gcontent;

    //-----------------------------------------------------------------------------------------------------
    /**
     * SamplePage
     *
     * @author Jindřich Vácha
     * @since 480.2.0.0
     */
    @gcontent
    export class SamplePage extends GContentBase {

        /**
         * model
         * @type {Gordic.Uda.WebControls.SamplePageDto}
         */
        protected model: Gordic.Uda.WebControls.SamplePageDto;

        //-----------------------------------------------------------------------------------------------------
        /**
         * Definice formuláře
         */
        public onContentReady(): void {

            this.taskId = "actSamplePage";

            let that = this;

            console.log("Gordic.Uda.WebControls.SamplePage.onContentReady", this);

            // akce seznamu
            this.actions.addRange({
                actSample: {
                    name: "actSample",
                    caption: "Sample " + this.model.ixp,
                    icon: "gi-detail",
                    run: function (ev, ctx) {
                        alert(1);
                    }
                }
            });

            this.menuBar(this.actions.createBar(["actSample*"]));

        } // onContentReady

    } // cls
} // ns